import { IDLE_MAINTENANCE, MaintenanceSnapshot } from "./types"

type Listener = (status: MaintenanceSnapshot) => void

const listeners = new Set<Listener>()

export function subscribeMaintenance(listener: Listener) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function emitMaintenance(status: MaintenanceSnapshot) {
  listeners.forEach((listener) => listener(status))
}

export function emitMaintenanceEnabled(title?: string, message?: string) {
  emitMaintenance({
    ...IDLE_MAINTENANCE,
    enabled: true,
    title: title || "We'll be back soon",
    message: message || "The platform is undergoing scheduled maintenance. Please try again later."
  })
}
